export const colors = {
    primary: "#5064DE",
    primaryHighlighted: "#3246C0",

    secondary: "#FFFFFF",
    secondaryHighlighted: "#E5EAFF",

    disabled: "#EEEEEE",
    disabledHighlighted: "#AFAFAF",

    error: "#FF897D",
    errorHighlighted: "#E16B5F",

    white: "#FFFFFF",

    text: "#444C68",
    secondaryText: "#676879",
    disclaimerText: "#878787",

    positive: "#6E9652",
    negative: "#B63546",

    transparent: "transparent",
    halfTransparentBlack: 'rgba(0, 0, 0, 0.5)',

    darkIndigo: "#3D348B",
    warning: "#FFCB00",
    gray: "#7A7A7A",
    pressed: "#F7F8FF",

    winter: "#9AADBD",
    orange: "#F18701",
    purple: '#6B47B7',

    greyBackground: "#F5F6F8",

    meterColorScale: ["#E2445C", "#F18701", "#FFCB00", "#AAD28E", "#6E9652"],
    doughnutChartColorScale: ["#3D348B", "#F7B801", "#7678ED", "#F18701", "#F35B04", "#784BD1", "#A1E3F6", "#4ECCC6", "#2B76E5", "#A9BEE8",],
    statusBackgroud: ["#FFF2E2", "#F5F6F8", "#F5F6F8", "#EEF5E9", "#FFEEEB", "#FFEEEB"],

    ExistingRecommended5ColorScale: ["#BB3354", "#E2445C", "#F18701", "#FFCB00", "#AAD28E"],
    ExistingRecommended6ColorScale: ["#6E9652", "#AAD28E", "#FFCB00", "#F18701", "#E2445C", "#BB3354"],

    existingRecommendedBarColors: ["#AAD28E", "#AFAFAF"],

    darkRed: "#BB3354",
    red: "#E2445C",
}